import { AuditLogTable } from 'src/components/molecules';
import {
  AuditEntryType,
  useGetCaseDataDownloadAuditEntriesQuery,
} from 'src/graphql/generated';
import { formatDateTime } from 'src/utils/commonFunctions';
interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const CaseDataDownloadAuditLogTable = ({ isOpen, setIsOpen }: Props) => {
  const { data: caseDataDownloadAuditEntries } =
    useGetCaseDataDownloadAuditEntriesQuery();

  const columns = [
    { label: 'User' },
    { label: 'Event' },
    { label: 'Timestamp' },
  ];

  const tableDataCallback = (entry: AuditEntryType) => {
    return {
      cellData: [
        entry.User?.name || entry.User?.displayName || 'System',
        'Case data downloaded',
        formatDateTime(new Date(entry.createdAt)),
      ],
      row: `${entry.id}`,
    };
  };

  return (
    <AuditLogTable
      auditLogEntries={
        (caseDataDownloadAuditEntries?.caseDataDownloadAuditEntries as AuditEntryType[]) ??
        []
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      columns={columns}
      tableDataCallback={tableDataCallback}
      emptyText="No case data download audit log entries."
    />
  );
};
